
import React from 'react';
import PropTypes from 'prop-types';

import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import BuildIcon from '@material-ui/icons/Build';

export const ActionsSnackBar = (props) => {

  const {postponedActions, dispatchDismissPostponedActionsAction,
    showFailedActionsHandler, dispatchDispatchPostponedActionsAction, theme} = props;

  return(
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={postponedActions && postponedActions.size > 0}
      autoHideDuration={300000}
      onClose={(event, reason) => {
        if (reason !== 'clickaway') {
          dispatchDismissPostponedActionsAction(postponedActions);
        }
      }}
      message={
        <span>
          <span
            id="message-id"
          >
            We were unable to make your changes. Please&nbsp;
          </span>
          <span
            id="try-again-id"
            aria-label="try again"
            style={{
              color: theme && theme.palette && theme.palette.linkColor,
              cursor: 'pointer',
            }}
            role="button"
            tabIndex="0"
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                dispatchDispatchPostponedActionsAction(postponedActions);
              }
            }}
            onClick={() => dispatchDispatchPostponedActionsAction(postponedActions)}
          >
            try again.
          </span>
        </span>
      }
      action={[
        process.env.NODE_ENV !== 'production' &&
        <IconButton
          key="details"
          aria-label="details"
          color="primary"
          size="small"
          onClick={showFailedActionsHandler}
        >
          <BuildIcon />
          {postponedActions.size}
        </IconButton>,
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={() => dispatchDismissPostponedActionsAction(postponedActions)}
        >
          <CloseIcon />
        </IconButton>,
      ]}
    />
  )
};

ActionsSnackBar.propTypes = {
  postponedActions: PropTypes.object,
  dispatchDismissPostponedActionsAction: PropTypes.func,
  dispatchDispatchPostponedActionsAction: PropTypes.func,
  showFailedActionsHandler: PropTypes.func,
  theme: PropTypes.object,
};
